export const FPT_PROVIDER_USER_IDENTITY_INPUT_PROPS = {
  autoComplete: 'off',
  id: 'fpt_cloud_signature_provider_user_identity',
  name: 'fptCloudSignatureProviderUserIdentity',
} as const;

export const FPT_PASSCODE_INPUT_PROPS = {
  autoComplete: 'off',
  id: 'fpt_cloud_signature_passcode',
  name: 'fptCloudSignaturePasscode',
  type: 'password',
} as const;
